import appTools from '../utils/Tools'
import {appId,payKey} from "../config";
import md5 from '../utils/Md5'
class Pay {
    constructor() {
        this.__init()
    }

    __init() {
    	const that = this;
    }
    pay(prepayId,nonceStr){
        let timestamp = ((new Date().getTime() /1000) +"").substring(0,10);
        let signType = 'MD5';
        var params = {timeStamp: timestamp,nonceStr: nonceStr,package: "prepay_id="+prepayId,signType: signType,appId:appId};
        var keys= "timeStamp,nonceStr,package,signType,appId".split(",").sort();
        var paramStr = "";
        for(var i = 0 ; i < keys.length ; i++){
            paramStr += "&" + keys[i] + "=" + params[keys[i]];
        }
        paramStr = paramStr.substring(1) +"&key="+payKey;
        console.info(paramStr)
        var paySign = md5.hex_md5(paramStr).toUpperCase();
        params["paySign"] = paySign;
        console.info(params)
        return params;
    }
}

export default new Pay();
